export default __webpack_public_path__ + "static/media/holmasto-gold-nuggets.91f3a7ec.jpeg";